import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.643365 20L0.189091 19.8115C-0.0630305 19.5571 -0.0630305 19.1528 0.189091 18.8984L18.9007 0.187382C19.1505 -0.0624619 19.5594 -0.0624619 19.8092 0.187382C20.0636 0.439497 20.0636 0.84601 19.8092 1.1004L1.09764 19.8115L0.643365 20Z",
		fill: "#272525"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.3549 20L18.9007 19.8115L0.189091 1.1004C-0.0630305 0.846012 -0.0630305 0.439499 0.189091 0.187384C0.438942 -0.0624599 0.847789 -0.0624599 1.09764 0.187384L19.8092 18.8984C20.0636 19.1528 20.0636 19.5571 19.8092 19.8115L19.3549 20Z",
		fill: "#272525"
	})]
});
export { SvgCloseAlt as ReactComponent };
